'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

exports.default = function (engine) {
  var whitelist = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
  var blacklist = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  whitelist = whitelist || []; // eslint-disable-line no-param-reassign

  return _extends({}, engine, {
    save: function save(state) {
      var whitelistIsEmpty = !whitelist.length;
      var blacklistIsEmpty = !blacklist.length;
      var stateIsMap = _immutable.Map.isMap(state);

      // Create a deep immutable map of state for easy reducing...
      var stateMap = stateIsMap ? (0, _immutable.fromJS)(state.toJS()) : (0, _immutable.fromJS)(state);

      // Create a state map with whitelist applied...
      var stateMapWithWhitelistApplied = whitelistIsEmpty && !blacklistIsEmpty ? stateMap : whitelist.reduce(function (memo, whitelistedKeyPath) {
        var whitelistedKeyPathArray = _getKeyPathArray(whitelistedKeyPath);
        var whitelistedKeyStateValue = stateMap.getIn(whitelistedKeyPathArray);

        return stateMap.hasIn(whitelistedKeyPathArray) || whitelistedKeyStateValue === null ? memo.setIn(whitelistedKeyPathArray, whitelistedKeyStateValue) : memo;
      }, new _immutable.Map());

      // Create a state map with blacklist and whitelist applied...
      var stateMapWithBlacklistAndWhitelistApplied = blacklist.reduce(function (memo, blacklistedKeyPath) {
        var blacklistedKeyPathArray = _getKeyPathArray(blacklistedKeyPath);

        return memo.deleteIn(blacklistedKeyPathArray);
      }, stateMapWithWhitelistApplied);

      // Convert state map with blacklist and whitelist applied to plain
      // js object.
      var saveState = stateMapWithBlacklistAndWhitelistApplied.toJS();
      return engine.save(saveState);
    }
  });
};

// (Private helpers)


function _getKeyPathArray(keyPath) {
  // Support string-type key paths for shallow paths
  if (typeof keyPath === 'string') {
    return [keyPath];
  }

  return keyPath;
}